import { React, useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Form, Spin, Switch, Tooltip } from 'antd';
import Box from '@iso/components/utility/box';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import { SelectOption } from '@iso/components/uielements/select';
import { useNavigate } from 'react-router-dom';
import ContentHolder from '@iso/components/utility/contentHolder';
import api from '../../../api';
import { AppContext } from '../../../context/ContextProvider';
// import { AlertContext } from '../../../context/alertContext';
// import awsLogo from '../../../assets/images/aws.svg';
// import customScriptIcon from '@iso/assets/images/custom-script-icon.svg';
// import secretDetectionIcon from '@iso/assets/images/secret-detection-icon.svg';
// import sonarcubeIcon from '@iso/assets/images/sonarcube-icon.svg';
// import checkmarkIcon from '@iso/assets/images/checkmark-icon.svg';
// import plusIcon from '@iso/assets/images/plusIcon.svg';
import { formatErrors, hasPermission, timeSince } from '../../../context/helper';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { StickerWidgetWrapper } from '../../Widgets/SmallCards/SmallCards.styles';
import noDataPlusIcon from '@iso/assets/images/nodata-plus-icon.svg';
import noDataImg from '@iso/assets/images/no-data-found.svg';
import kubernetesIcon from '@iso/assets/images/icon/kubernetes-logo.png';
import Select from '@iso/containers/Deployments/Deployment.styles';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';

const Option = SelectOption;

const noDataSubTitle = {
    color: "#323232",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    marginLeft: "5px"
};
let boxTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "1px",
};

let boxSubtitleStyle = {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

const noDataTitle = {
    color: "#A6A6A6",
    textAlign: "center",
    fontFamily: "Nunito Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
};


const widgetStyle = {
    margin: "20px",
    width: "100%",
    position: "relative",
};

const MultiSelect = styled(Select)`
.ant-select-selector {
  min-height: 44px !important;
  height: auto !important;
}
  .ant-select-selection-overflow-item {
    width: 100%;
  }
  .ant-select-selection-item {
    width: 100%;
    height: 44px !important;
    min-height: 42px !important;
  }
  .ant-select-selection-item-content {
    width: 100%;
  }
  .ant-select-selection-item {
    background: #f5f5f5;
  }
`;


export default ({
    workflowNodeData,
    workflowEdgesData,
    // serviceId,
    columnId,
}) => {

    const [form] = Form.useForm();
    const navigate = useNavigate();

    const { openRightDrawer, setOpenRightDrawer, workflowData, setWorkflowData, setWorkflowNodeData, setWorkflowEdgesData, currentWorkflowData, workflowTypeExecution, setWorkflowTypeExecution, setCurrentWorkflowData, setOpenModel } = useContext(AppContext);
    // const { alertOptions, set_alertOptions } = useContext(AlertContext);

    const [deployData, setDeployData] = useState({
        envName: currentWorkflowData?.deployConfig?.config?.env_name ? currentWorkflowData.deployConfig.config.env_name : "",
        envId: currentWorkflowData?.deployConfig?.config?.env_unique_id ? currentWorkflowData.deployConfig.config.env_unique_id : "",
        error: null,
        buildType: currentWorkflowData?.deployConfig?.config?.build_type ? currentWorkflowData.deployConfig.config.build_type : "Automatic",
        hasApprovers: currentWorkflowData?.deployConfig?.config?.has_approvers ? currentWorkflowData.deployConfig.config.has_approvers : false,
        approvers: currentWorkflowData?.deployConfig?.config?.approvers ? currentWorkflowData.deployConfig.config.approvers : [],
        approvedBy: currentWorkflowData?.deployConfig?.config?.approved_by ? currentWorkflowData.deployConfig.config.approved_by : "",
        rejectedBy: currentWorkflowData?.deployConfig?.config?.rejected_by ? currentWorkflowData.deployConfig.config.rejected_by : "",
        timestamp: currentWorkflowData?.deployConfig?.config?.timestamp ? currentWorkflowData.deployConfig.config.timestamp : "",
        calculatedTimestamp: currentWorkflowData?.deployConfig?.config?.timestamp ? `${timeSince(new Date(currentWorkflowData?.deployConfig?.config?.timestamp))} ago` : "",
        comment: currentWorkflowData?.deployConfig?.config?.comment ? currentWorkflowData.deployConfig.config.comment : "",
    });

    const [envDropdown, setEnvDropdown] = useState([]);
    const [fetching, setFetching] = useState(true);
    const [error, setError] = useState(null);
    const [approvesOptions, setApprovesOptions] = useState([]);
    const [fetchingUsersList, setFetchingUsersList] = useState(false);
    const [autoTriggerOptions, setAutoTriggerOptions] = useState([]);

    // const navigate = useNavigate();
    // const location = useLocation();

    const handelCancel = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    }

    // creating Build Type options
    useEffect(() => {
        let tempAutoTriggerDropdown = [];

        ["Automatic", "Manual"].forEach((child, ind) => {
            tempAutoTriggerDropdown.push(
                <Option key={child} name="buildType" data-id="" data-region={null} value={child}>
                    <div style={{ width: "100%", display: "flex" }}>
                        <p> {child} </p>
                    </div>
                </Option>
            );
        });

        setAutoTriggerOptions(tempAutoTriggerDropdown);
    }, []);

    const fetchEnvList = async () => {
        console.log("currentWorkflowData in deployClickRightDrawer :", currentWorkflowData);
        let query = `?service_id=${currentWorkflowData?.serviceId}`;     // &account_id=${currentWorkflowData?.accountId}
        if (currentWorkflowData?.deployConfig?.config?.env_unique_id) {
            query = query + `&env_unique_id=${currentWorkflowData.deployConfig.config.env_unique_id}&env_var_at_build_time=true`
        }
        else {
            query = query + `&env_var_at_build_time=true`
        }


        // if ([true, false].includes(currentWorkflowData.pass_env_vars_at_build_time)) {
        //     query = query + `&env_var_at_build_time=${currentWorkflowData.pass_env_vars_at_build_time}`
        // }

        setFetching(true);

        try {
            const { data } = await api.get(
                `${process.env.REACT_APP_API_URI}/api/project_env/env/create/${query}`
            );

            console.log('env list:', data);

            if (data.status) {
                let myEnvs = [];

                let arr = data.data.sort((a, b) => (a.name.localeCompare(b.name)));

                const envToolsArr = Array.isArray(currentWorkflowData?.deployConfig?.tools) ? currentWorkflowData.deployConfig.tools : [];
                let listOfEnvsAlreadySelected = envToolsArr.map((item) => item.envId);
                console.log("listOfEnvsAlreadySelected :", listOfEnvsAlreadySelected);

                arr.map((temp, idx) => {
                    // Only active, updating and error phase env's
                    if ([0, 1, 2, 3, 8, 12].includes(temp.phase) && !listOfEnvsAlreadySelected.includes(temp.env_unique_id)) {
                        console.log("temp :", temp);
                        myEnvs.push(<Option key={idx} name="envName" data-id={temp.env_unique_id} value={temp.name}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                <div>
                                    <img src={temp.account_logo ? temp.account_logo : kubernetesIcon} style={{ width: "18px", height: "18px", marginRight: "10px" }} alt="icon" onError={(e) => { e.target.onerror = null; e.target.src = kubernetesIcon; }} />
                                    <span>{temp.name}</span>
                                </div>
                                {/* <span>{temp.cluster_type}</span> */}
                            </div>
                        </Option>)

                        // when user opens deploy drawer first time - on update
                        if (currentWorkflowData.deployConfig.enabled === true && currentWorkflowData.deployConfig.config.environments && temp.env_unique_id === currentWorkflowData.deployConfig.config.environments[0].env_unique_id) {
                            console.log("Found :", temp);
                            console.log("deployData :", JSON.parse(JSON.stringify(deployData)));
                            setDeployData((prev) => ({ ...prev, envName: temp.env_name, envId: temp.env_unique_id, error: null }));
                            form.setFieldsValue({ envName: temp.env_name, envId: temp.env_unique_id, error: null });
                        }
                    }
                });

                // If env is selected by user then below
                if (currentWorkflowData.deployConfig.enabled === true && currentWorkflowData.deployConfig.config.env_unique_id) {
                    console.log("changing again :", currentWorkflowData.deployConfig.config);
                    setDeployData((prev) => ({ ...prev, envName: currentWorkflowData.deployConfig.config.env_name, envId: currentWorkflowData.deployConfig.config.env_unique_id, error: null }));
                    form.setFieldsValue({ envName: currentWorkflowData.deployConfig.config.env_name, envId: currentWorkflowData.deployConfig.config.env_unique_id, error: null });
                }

                setEnvDropdown(myEnvs);
                // setEnvList(data.data);
            }
            else if (!data.status) {
                let err = formatErrors(data.error_details);
                console.log("err in project_env/create :", err);
            }
        } catch (error) {
            console.log('err :', error);
        } finally {
            setFetching(false);
        }
        // api.get(process.env.REACT_APP_API_URI + `/api/project_env/env/create/${query}`)
        //     .then((res) => {
        //         let data = res.data;
        //         console.log("env list :", data);
        //     }).catch((err) => {
        //         console.log("err :", err);
        //         setFetching(false);
        //     });
    }

    // get env list having service_id
    useEffect(() => {
        fetchEnvList();
        // if there is an error, validate the form fields

        if (currentWorkflowData?.deployConfig?.isError) {
            form.validateFields();
        }
    }, []);

    // Check if env is valid
    useEffect(() => {
        console.log("deployData in validate_env :", deployData);
        console.log("currentWorkflowData.deployConfig.config in validate_env :", currentWorkflowData?.deployConfig?.config);
        if (currentWorkflowData && !currentWorkflowData?.fromPipeline && deployData.envId && deployData.envId !== currentWorkflowData.deployConfig.config.env_unique_id) {
            api.get(process.env.REACT_APP_API_URI + `/api/pipelines/workflows/validate_env/${deployData.envId}/${currentWorkflowData.serviceId}`)
                .then(async (res) => {
                    let data = res.data;
                    console.log("workflows/validate_env data :", data);
                    if (data.status) {
                        if (data.data.exists) {
                            // let msg = data.data.message + ` If you save or execute the changes your workflow(${data.data.workflow_name}) will be replaced by the current workflow(${currentWorkflowData.workflowName}).`;
                            let msg = data.data.message;
                            setDeployData((prev) => ({ ...deployData, error: msg }));
                            setError(msg);
                            form.setFieldsValue({
                                ...deployData,
                                error: msg,
                            });
                        }
                        else {
                            setDeployData((prev) => ({ ...deployData, error: null }));
                            form.setFieldsValue({
                                ...deployData,
                                error: null,
                            });
                            setError(null);
                        }
                    }
                    else if (!data.status) {
                        let err = formatErrors(data.error_details);
                        setDeployData((prev) => ({ ...deployData, error: null }));
                        console.log("err in env check api :", err);
                    }
                }).catch((err) => {
                    setDeployData((prev) => ({ ...deployData, error: null }));
                    console.log("err :", err);
                });
        }
    }, [deployData.envId]);
    
    // get user lists with approve_permission
    useEffect(() => {
        // if(!currentWorkflowData?.fromPipeline){
            // console.log("currentWorkflowData.deployConfig.config in validate_env :", currentWorkflowData?.deployConfig?.config);
            console.log("deployData in validate_env :", deployData);
            setFetchingUsersList(true);
            
            api.get(process.env.REACT_APP_API_URI + '/api/pipelines/pipeline-deployment/approvers-list/')
            .then(async (res) => {
                let data = res.data;
                console.log("approvers-list data :", data);
                if (data.status) {
                    let tempData = [];
                    let approversIds = [];

                    data.data.approvers.map((item, idx) => {
                        tempData.push(<Option key={idx} name="approvers" value={item.id}>{item.email}</Option>);

                        approversIds.push(item.id);
                    });

                    console.log("approversIds :", approversIds);
                    console.log("deployData :", JSON.parse(JSON.stringify(deployData)));
                    // remove approvers from step -> env if not in approvers list.
                    if(deployData.approvers && deployData.approvers.length > 0){
                        let tempApprovers = deployData.approvers.filter((item) => approversIds.includes(item));
                        console.log("tempApprovers :", tempApprovers);
                        setDeployData((prev) => {

                            form.setFieldsValue({
                                ...prev,
                                approvers: tempApprovers,
                            });

                            return { ...prev, approvers: tempApprovers }
                        });
                    }
    
                    setApprovesOptions(tempData);
                }
                else if (!data.status) {
                    let err = formatErrors(data.error_details);
                    console.log("err :", err);
                    setApprovesOptions([]);
                }
            }).catch((err) => {
                console.log("err :", err);
                setApprovesOptions([]);
            }).finally(() => {
                setFetchingUsersList(false);
            });
        // }
    }, []);

    useEffect(() => {
        const test = async () => {
            if (deployData.error) {
                try {
                    const values = await form.validateFields();
                    console.log('Success:', values);
                }
                catch (err) {
                    console.log("Found error :", err);
                }
            }
        }

        test();
    }, [deployData.error]);


    // const handleClick = (type) => {
    //     console.log("clicked handleClick :", type);
    //     setOpenRightDrawer({
    //         drawerType: type,
    //         drawerProps: {
    //             data: workflowData,
    //             columnId: columnId,
    //             type: "source",
    //             className: "expend",
    //         },
    //     });
    // }

    const handelAdd = () => {
        // let tempNodeData = [];
        // let tempEdgesData = [];
        // let targetIndex = 0;  // as this is sourceNode
        // let idOrders = [];
        // let toolsCount = 0;
        let sourceToolsCount = 0;
        let buildToolsCount = 0;
        let deployToolsCount = 0;

        console.log("workflowNodeData at beginning :", JSON.parse(JSON.stringify(workflowNodeData)));
        console.log("workflowEdgesData at beginning :", JSON.parse(JSON.stringify(workflowEdgesData)));
        console.log("currentWorkflowData at beginning :", JSON.parse(JSON.stringify(currentWorkflowData)));

        let workflowTempNodeData = [];
        // remove any build tool node if there is any previously
        const safeWorkflowNodeData = Array.isArray(workflowNodeData) ? workflowNodeData : [];
        safeWorkflowNodeData.map((item, idx) => {
            console.log("checking ids order list :", item);

            if (item.type === "sourceToolNode") {
                sourceToolsCount = sourceToolsCount + 1;
            }
            else if (item.type === "buildToolNode") {
                buildToolsCount = buildToolsCount + 1;
            }
            else if (item.type === "deployToolNode") {
                deployToolsCount = deployToolsCount + 1;
            }

            console.log("item.type :", item.type);
            console.log("item.type :", item.type !== "deployToolNode");
            // remove deployTool if already exist
            if (item.type !== "deployToolNode") {
                workflowTempNodeData.push(item);
            }
            else {
                console.log("idx :", idx);
                workflowEdgesData.splice(idx - 1, 1, null);
            }
        });

        // set temp data for workflowEdgesData
        const safeWorkflowEdgesData = Array.isArray(workflowEdgesData) ? workflowEdgesData : [];
        let workflowTempEdgesData = safeWorkflowEdgesData.filter((temp) => temp);

        let deployToolStartFrom = sourceToolsCount + buildToolsCount + deployToolsCount + 3   // sourceToolsNode + buildToolsNode + deployToolsCount + (Source node + build node + deploy node)
        // console.log("workflowData in add new :", JSON.parse(JSON.stringify(workflowData)));
        // console.log("sourceToolsCount :", sourceToolsCount);
        // console.log("buildToolsCount :", buildToolsCount);
        // console.log("deployToolStartFrom :", deployToolStartFrom);
        // console.log("workflowTempNodeData in middle :", JSON.parse(JSON.stringify(workflowTempNodeData)));
        // console.log("workflowTempEdgesData in middle :", JSON.parse(JSON.stringify(workflowTempEdgesData)));
        // Guard: tools array may be undefined in some flows
        const deployTools = Array.isArray(currentWorkflowData?.deployConfig?.tools) ? currentWorkflowData.deployConfig.tools : [];
        deployTools.map((temp, idx) => {
            console.log("workflowData.postDeployToolsData -> temp :", temp);

            let myNodeObj = {
                id: "",
                type: "deployToolNode",
                data: { label: "Deploy", id: idx + deployToolStartFrom, indx: idx, type: "deployToolNode" },
                position: {
                    x: currentWorkflowData?.fromPipeline ? 401 : 800,
                    y: currentWorkflowData?.fromPipeline ? 80 * (idx + 1) : 200 * (idx + 1)
                },   // 2nd node should be below first node
                style: { borderRadius: "20px" },
            }

            let myEdgeObj = {
                id: "",
                source: "",
                target: "",
                animated: false,
                // animated: false,
                style: { stroke: "#F7F6FA", strokeWidth: 3 },
            }

            workflowTempNodeData.splice(idx + deployToolStartFrom, 0, myNodeObj);
            workflowTempEdgesData.splice(idx + deployToolStartFrom, 0, myEdgeObj);
        });

        workflowTempNodeData.push({
            id: "",
            type: "deployNode",
            data: { label: "Deploy", toolsOrder: [0, 1, 2] },
            position: { x: 800, y: 50 },
            style: { borderRadius: "20px" },
            // sourcePosition: "left",
        });

        workflowTempEdgesData.push({
            id: "",
            source: (workflowTempNodeData.length - 2).toString(),
            target: (workflowTempNodeData.length - 1).toString(),
            animated: false,
            style: { stroke: "#ecf4fb", strokeWidth: 3 },
        });


        // position: let x, y = 0, 0;
        workflowTempNodeData.map((temp, idx) => {
            // Node
            // {
            //     id: "1",
            //     type: "sourceNode",
            //     data: { label: "Source" },
            //     position: { x: 0, y: 50 },
            //     style: { borderRadius: "20px" },
            //     sourcePosition: "right",
            //   },
            // let position = idx === targetIndex+1 ? { x: 0, y: 50 } : temp.position;
            console.log("idx :", idx);
            console.log("temp :", temp);

            workflowTempNodeData[idx] = {
                ...workflowTempNodeData[idx],
                id: `${idx + 1}`,   // should start from 1 index
                type: temp.type,
                data: temp.data,
                // position: { x: 450, y: 200 },
                position: temp.position,
            }

            // tempNodeData.push();
        });

        // For Edges
        workflowTempEdgesData.map((temp, idx) => {
            // Edge
            // {
            //     id: "e1-2",
            //     source: "1",
            //     target: "2",
            //     animated: false,
            //     style: { stroke: "#fff" },
            //   },

            // source will always remain at it's position
            if (idx != 0) {
                workflowTempEdgesData[idx] = {
                    ...workflowTempEdgesData[idx],
                    id: `e${idx + 1}-${idx + 2}`,
                    source: `${idx + 1}`,
                    target: `${idx + 2}`,
                }
            }

            // tempEdgesData.push();
        });

        console.log("workflowTempNodeData :", workflowTempNodeData);
        console.log("workflowTempEdgesData :", workflowTempEdgesData);

        let filteredEdgeData = workflowTempEdgesData.filter((item, idx) => item.source && parseInt(item.source) < workflowTempNodeData.length)
        console.log("filteredEdgeData :", filteredEdgeData);

        setWorkflowNodeData([...workflowTempNodeData]);
        setWorkflowEdgesData([...filteredEdgeData]);
        // we can't perform below because it will impact build tool add
        // setWorkflowTypeExecution({
        //     source: true,
        //     build: false,
        //     deploy: currentWorkflowData.withoutCI ? true : false
        // });
    }

    const saveEnvChanges = () => {
        console.log("inside saveEnvChanges...")

        if (!currentWorkflowData.deployConfig.enabled) {
            handelAdd();
        }

        currentWorkflowData.deployConfig.enabled = true;
        currentWorkflowData.deployConfig.isError = false;

        currentWorkflowData.deployConfig.config = {
            ...currentWorkflowData.deployConfig.config,
            env_unique_id: deployData.envId,
            env_name: deployData.envName,
            build_type: deployData.buildType,
            has_approvers: deployData.hasApprovers,
            approvers: deployData.approvers,
        };

        // check if environments exists
        if (!currentWorkflowData.deployConfig?.config?.environments) {
            currentWorkflowData.deployConfig.config["environments"] = [{
                env_unique_id: deployData.envId,
                env_name: deployData.envName,
                build_type: deployData.buildType,
            }];
        }

        setCurrentWorkflowData({ ...currentWorkflowData, deployConfig: { ...currentWorkflowData.deployConfig } });
        setWorkflowTypeExecution(JSON.parse(JSON.stringify({ ...workflowTypeExecution, deploy: true })));
        localStorage.setItem("Workflow", JSON.stringify({ ...currentWorkflowData, deployConfig: { ...currentWorkflowData.deployConfig } }));
        handelCancel();

        setOpenModel({
            modalType: false,
            modalProps: {
                data: null,
            },
        });
    }

    const handleSaveDetails = async (e) => {
        console.log("clicked handleSaveDetails...",);
        try {
            const values = await form.validateFields();
            console.log('Success:', values);
            saveEnvChanges();
        }
        catch (err) {
            console.log("Found error :", err);
            if (err.errorFields[0].errors[0] === deployData.error) {
                // "CONFIRM_ACTION"
                setOpenModel({
                    modalType: 'CONFIRM_ACTION',
                    modalProps: {
                        data: "",
                        title: "Save Workflow?",
                        subTitle: <span style={{ display: "block" }}>
                            <p>Are you sure you want to save this environment?</p>
                            {deployData.error && <p style={{ color: "#CB444A", fontSize: "12px", marginTop: "15px" }}> Note: {deployData.error}</p>}
                        </span>,
                        cancelButton: "Cancel",
                        saveButton: "Save",
                        onConfirm: () => { console.log("onConfirm"); saveEnvChanges() },
                        onCancel: () => { console.log("onCancel") },
                        columnId: null,
                        className: "large-Box"
                    },
                });
            }
        }
    }

    const handleSelectChange = (value, event) => {
        console.log("clicked handleSelectChange...");
        if (event.name === "env-redirect") {
            navigate(`/environments/create`, {
                state: {
                    data: null,
                    from: "workflow-deploy"
                }
            });
        }
        else if (event.name === "buildType") {
            setDeployData({ ...deployData, buildType: value });
            form.setFieldsValue({ ...deployData, buildType: value });
        }
        else {
            setDeployData({ ...deployData, envName: value, envId: event["data-id"], error: null });
            form.setFieldsValue({ ...deployData, envName: value, envId: event["data-id"], error: null });
        }
    }

    const handleMultiSelectChange = (value, event) => {
        // console.log('event :', event);
        // console.log('value :', value);
        setDeployData({ ...deployData, approvers: value });
        form.setFieldsValue({ ...deployData, approvers: value });
    };

    const handleCancel = (e) => {
        console.log("clicked handleCancel...");
        handelCancel();
    }


    return (
        <LayoutWrapper className="clusterInfo" style={{ padding: "0" }}>
            <CreateTaskHeader buttonContent={columnId} onCancel={handelCancel} />

            <div style={{ marginTop: "84px", width: "100%" }} />

            <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "20px" }}>
                <Form
                    form={form}
                    initialValues={{ ...deployData }}
                    preserve={false}
                    name="dynamic_rule"
                    style={{
                        width: "100%",
                        height: "fit-content"
                    }}
                >
                    <Box
                        title={`Environment${currentWorkflowData?.fromPipeline ? "" : "*"}`}
                        subtitle={"Dropdown contains list of environments which have same service."}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ width: "100%", marginTop: "0", border: "0", padding: "0", marginBottom: "0px" }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                            <Form.Item
                                name="envName"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select Environment.',
                                    },
                                    {
                                        // Custom validator
                                        validator: (_, value) => {
                                            console.log("deployData in validator :", deployData);
                                            if (value && deployData.error) {
                                                return Promise.reject(new Error(error));
                                            }
                                            else {
                                                return Promise.resolve();
                                            }
                                        }
                                    }
                                ]}
                            >
                                <Select
                                    value={deployData?.envName ? deployData?.envName : undefined}
                                    placeholder={"Select Environment"}
                                    onChange={handleSelectChange}
                                    style={{ width: "100%" }}
                                    disabled={currentWorkflowData?.fromPipeline}
                                    data-testid="workflow-tool-environment-select"
                                >
                                    {fetching ?
                                        <Option>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                <Spin size="small" />
                                            </div>
                                        </Option>
                                        : envDropdown.length > 0
                                            ? envDropdown
                                            : <Option key="0" name="env-redirect" data-alias="" type="integration" style={{ background: "white" }}>
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
                                                    <img src={noDataImg} />
                                                    <span style={noDataTitle}>No Environments available.</span>
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <img src={noDataPlusIcon} />
                                                        <span style={noDataSubTitle}>Create one</span>
                                                    </div>
                                                </div>
                                            </Option>
                                    }
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>

                    <Box
                        title={`Deployment Type${currentWorkflowData?.fromPipeline ? "" : "*"}`}
                        subtitle={"Select deployment type from the following."}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ width: "100%", marginTop: "0", border: "0", padding: "0" }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                            <Form.Item
                                name="buildType"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide deployment type.',
                                    },
                                ]}
                            >
                                <Select
                                    value={deployData?.buildType ? deployData.buildType : undefined}
                                    placeholder="Select"
                                    onChange={handleSelectChange}
                                    style={{ width: "100%" }}
                                    disabled={currentWorkflowData?.fromPipeline}
                                    data-testid="workflow-tool-environment-deployment-type-select"
                                >
                                    {autoTriggerOptions}
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>
                    
                    <div>
                        <Box
                            title={`Add Approvers`}
                            subtitle={"Toggle on the switch to add approvers to this workflow."}
                            titleStyle={boxTitleStyle}
                            subTitleStyle={boxSubtitleStyle}
                            style={{ width: "100%", marginTop: "0", border: "0", padding: "0", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: deployData.hasApprovers ? "24px" : "150px" }}
                        >
                            <ContentHolder style={{ width: "fit-content", marginTop: "0px", marginBottom: "0px" }}>
                                <Form.Item
                                    name="hasApprovers"
                                    // rules={[
                                    //     {
                                    //         required: true,
                                    //         message: 'Please provide approvers.',
                                    //     },
                                    // ]}
                                >
                                    <Tooltip title={(!hasPermission("add_approver") && !currentWorkflowData?.fromPipeline) ? "You don't have permission to add approver to workflows" : ""}>
                                        <Switch style={{width: "fit-content", backgroundColor: deployData.hasApprovers ? "#132f44" : "" }}
                                            checked={deployData.hasApprovers}
                                            disabled={currentWorkflowData?.fromPipeline || !hasPermission("add_approver")}
                                            // onFocus={handleFocus}
                                            data-testid="workflow-tool-environment-add-approvers-toggle"
                                            onChange={(checked) => {
                                                setDeployData((prev) => {
                                                    form.setFieldsValue({
                                                        ...prev,
                                                        hasApprovers: checked
                                                    });

                                                    return { ...prev, hasApprovers: checked }
                                                });
                                            }}
                                        />
                                    </Tooltip>
                                </Form.Item>
                            </ContentHolder>
                        </Box>
                    </div>
                    
                    {deployData.hasApprovers && <Box
                        title={`Approvers`}
                        subtitle={"Only admins and selected users from dropdown will be able to approve workflow."}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ width: "100%", marginTop: "0", border: "0", padding: "0", marginBottom: (currentWorkflowData.fromPipeline && deployData.hasApprovers && (deployData.approvedBy || deployData.rejectedBy)) ? "0px" : "150px" }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                            <div style={{ marginBottom: "8px", color: "#9b9b9b", fontSize: "12px", fontFamily: "Nunito Sans", fontWeight: "400" }}>
                                Note: Users with the Admin role have implicit approval/reject rights for all workflows.
                            </div>
                            <Form.Item
                                name="approvers"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide Approvers.',
                                    },
                                ]}
                            >
                                {console.log("deployData.approvers :", deployData.approvers)}
                                <Tooltip title={(!hasPermission("add_approver")  && !currentWorkflowData?.fromPipeline) ? "You don't have permission to add approver to workflows" : ""}>
                                    <MultiSelect
                                        mode="multiple"
                                        showSearch
                                        allowClear
                                        name="approvers"
                                        style={{ width: '100%', minHeight: "44px", marginBottom: "10px" }}
                                        placeholder={"Select users to approve this workflow."}
                                        value={deployData.approvers ? deployData.approvers : undefined}
                                        onChange={(value, event) => {
                                            handleMultiSelectChange(value, event);
                                        }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        // disabled={currentWorkflowData?.fromPipeline}
                                        disabled={currentWorkflowData?.fromPipeline || !hasPermission("add_approver")}
                                        notFoundContent={fetchingUsersList ? <Spin size="small" /> : null}
                                        filterOption={(input, option) =>
                                            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {approvesOptions}
                                    </MultiSelect>
                                </Tooltip>
                            </Form.Item>
                        </ContentHolder>
                    </Box>}
                    
                    {currentWorkflowData.fromPipeline && deployData.hasApprovers && (deployData.approvedBy || deployData.rejectedBy) && <Box
                        title={deployData.approvedBy ? `Approved By` : "Rejected By"}
                        subtitle={deployData.approvedBy ? deployData.approvedBy : deployData.rejectedBy}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ width: "100%", marginTop: "0", border: "0", padding: "0", marginBottom: "24px" }}
                    >
                    </Box>}
                    
                    {currentWorkflowData.fromPipeline && deployData.hasApprovers && (deployData.approvedBy || deployData.rejectedBy) && <Box
                        title={deployData.approvedBy ? `Approved At` : "Rejected At"}
                        subtitle={deployData.calculatedTimestamp ? deployData.calculatedTimestamp  + ` (${new Date(deployData.timestamp).toLocaleString("en-US", { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })})` : "-"}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ width: "100%", marginTop: "0", border: "0", padding: "0", marginBottom: "24px" }}
                    >
                    </Box>}
                    
                    {currentWorkflowData.fromPipeline && deployData.hasApprovers && (deployData.approvedBy || deployData.rejectedBy) && <Box
                        title={"Comments"}
                        subtitle={deployData.comment ? deployData.comment : "-"}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ width: "100%", marginTop: "0", border: "0", padding: "0", marginBottom: "150px" }}
                    >
                    </Box>}
                </Form>
            </StickerWidgetWrapper>

            {!currentWorkflowData?.fromPipeline && <CreateTaskFooter buttonContent={"Source Config"} givenButtonFunction1={handleSaveDetails} givenButtonFunction2={handleCancel} saveButtonTestId="workflow-tool-environment-save-button" cancelButtonTestId="workflow-tool-environment-cancel-button" />}
        </LayoutWrapper>
    );
};